import { combineReducers } from "redux";
import { lopReducer } from "./lopReducer";
import { tietReducer } from "./tietReducer";
import { tuanReducer } from "./tuanReducer";
import { phongNamHocReducer } from "./phongNamHocReducer";
import { giaoVienReducer } from "./giaoVienReducer";
import { trangThaiReducer } from "./diemDanhTrangThaiReducer";

export const danhMucReducerWrapper = combineReducers({
   lop: lopReducer,
    tuan: tuanReducer,
    tiet: tietReducer,
    phongNamHoc: phongNamHocReducer,
    giaoVien: giaoVienReducer,
    trangThai: trangThaiReducer
})